import React, { Component } from 'react';
import { Footer } from '../Components/Footer';
import TitleCard from '../Components/TitleCard.js';
import Lottie from 'lottie-react';
import { ChevronRight } from 'lucide-react';
import sobreAnimation from '../assets/animations/sobre.json';
import { Link } from 'react-router-dom'; 

// import PeopleCard from '../Components/PeopleCard';

// const peopleList = [
//     {
//         image: '/images/people/priscila.jpeg',
//         alt: 'Priscila',
//         name: 'Priscila Kaiser',
//         office: 'Economista',
//         summary: 'Mestre em Economia pela PUCRS e pós-graduada em Data Science e Big Data pela PUC-Minas. Também, possui graduação em economia pela UFRGS. Atualmente é consultora de finanças públicas.',
//     },
//     {
//         image: '/images/people/uriel.jpeg',
//         alt: 'Uriel',
//         name: 'Uriel kveller',
//         office: 'Economista',
//         summary: 'Mestre em Análise de Política Econômica pela Universidade de Paris e Mestre em Economia pela Unicamp. Possui graduação em Economia pela UFRGS. Atualmente é consultor de finanças públicas.',
//     },
//     {
//         image: '/images/people/lucas.jpeg',
//         alt: 'Lucas',
//         name: 'Lucas Brum',
//         office: 'Profissional de Dados',
//         summary: 'Graduado em Análise e Desenvolvimento de Sistemas pela FAQI. Atualmente é consultor de Engenharia de Dados.',
//     },
// ];

class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date()
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {        
    }

    render() {       

        return (
            <div className="container">
                <div className='home-first-block home-blocks' style={{
                    backgroundImage: `
                        linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0) 15%),
                        linear-gradient(to bottom, rgba(255,255,255,0) 80%, #fff 100%),
                        url('/images/home/background.svg')
                `}}>
                    
                    <div className='home-first-block-left'>
                        <div style={{marginBottom: '30px'}}>
                            <img
                                src="/images/icons/home.svg"
                                width="18"
                                alt="Home"
                            />                        
                            <Link to="/" style={{color: '#818181', fontSize: '14px', marginLeft: '10px', textDecoration: 'none'}}>
                                Início
                            </Link>
                            <ChevronRight style={{width: '18px', color: '#818181', marginLeft: '5px'}}/>
                            <span style={{color: '#4654A3', fontSize: '14px', marginLeft: '5px'}}>Sobre a FiscalData</span>
                        </div>
                        <TitleCard
                            iconLeft={<img
                                src="/images/icons/Buildings.svg"
                                width="18"
                                alt="Buildings"
                            />}
                            label='QUEM SOMOS'
                            
                        />                                    
                        <span className='title-text' style={{marginTop: '25px', fontSize: '64px'}}>
                            Sobre a <br /> FiscalData
                        </span>
                        <span style={{marginBottom: '30px', color: 'gray'}}>
                            Somos um grupo de pesquisadores dedicados a garimpar e lapidar as bases de dados públicas com objetivo de contribuir com o debate dos grandes temas da política fiscal e tributária do país.
                        </span>         
                    </div>    
                    <div className='first-lottie'>
                        <Lottie animationData={sobreAnimation} loop={true} />
                    </div>
                    
                    
                </div>         
                <div className='home-first-block home-first-block-padding'>
                    <img
                        src="/images/about/afiscaldata.svg"
                        width="500"
                        alt="aFiscalData"
                    />   
                    <div className='home-first-block-left'>
                        <TitleCard
                            iconLeft={<img
                                src="/images/icons/conheca_fiscaldata.svg"
                                width="18"
                                alt="A FiscalData"
                            />}
                            label='A FISCALDATA'
                            
                        />                                    
                        <span className='title-text'>
                            Transformando dados em <br /> 
                            conhecimento para um <br />
                            Brasil mais transparente
                        </span>
                        <span style={{marginBottom: '30px', color: 'gray'}}>
                            A FiscalData nasceu para integrar a teoria das finanças <br />
                            públicas e economia com a tecnologia da informação,<br />
                            tornando o acesso a dados mais fácil e promovendo pesquisas<br />
                            de qualidade. Nosso compromisso é disponibilizar<br />
                            informações confiáveis tanto para a gestão pública quanto<br />
                            para a sociedade, fortalecendo o debate sobre transparência e<br />
                            desenvolvimento. <br /> <br />

                            Como think tank, atuamos no advocacy de políticas públicas,<br />
                            esclarecendo questões econômicas e fiscais essenciais para o<br />
                            país. Nosso propósito é simplificar o acesso à informação,<br />
                            mobilizar especialistas e articular atores da área fiscal,<br />
                            contribuindo para um debate público transparente e<br />
                            fundamentado.
                        </span>          
                    </div>                                                           
                    
                </div>     

                <div className='home-first-block home-blocks' style={{backgroundColor: '#FAFAFA'}}>
                    <div className='banners-block'>
                        <div>
                            <img
                                src="/images/icons/transparencia_qualidade.svg"
                                width="100"
                                alt="Transparência e Qualidade"
                            />
                            <span style={{fontWeight: 'bold', fontSize: '24px', marginTop: '45px'}}>Transparência e Qualidade</span>
                            <span style={{marginBottom: '30px', color: 'gray', marginTop: '10px'}}>Facilitamos o acesso a informações fiscais<br/>
                                confiáveis das três esferas da federação.
                            </span>
                        </div>
                        <div className='line'></div>
                        <div>
                            <img
                                src="/images/icons/parceria_institucional.svg"
                                width="100"
                                alt="Parceria Institucional"
                            />
                            <span style={{fontWeight: 'bold', fontSize: '24px', marginTop: '45px'}}>Parceria Institucional</span>
                            <span style={{marginBottom: '30px', color: 'gray', marginTop: '10px'}}>Desenvolvido com apoio da CCiF e<br/>
                                federações de fiscais municipais,estaduais <br/>
                                e federais.
                            </span>
                        </div>
                        <div className='line'></div>
                        <div>
                            <img
                                src="/images/icons/tecnologia_pesquisa.svg"
                                width="100"
                                alt="Tecnologia e Pesquisa"
                            />
                            <span style={{fontWeight: 'bold', fontSize: '24px', marginTop: '45px'}}>Tecnologia e Pesquisa</span>
                            <span style={{marginBottom: '30px', color: 'gray', marginTop: '10px'}}>Nossa plataforma usa tecnologia para <br/>
                            oferecer dados acessíveis e promover<br/>
                            análises estratégicas.</span>
                        </div>                        
                    </div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default About;
